import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { UserRoles } from 'uplisting-frontend/models/user';

export type InvitationRole = Exclude<UserRoles, UserRoles.accountOwner>;
export enum InvitationStatus {
  accepted = 'accepted',
  pending = 'pending',
}
export enum InvitationSubrole {
  reservations = 'reservations',
  finance = 'finance',
  operations = 'operations',
  maintenance = 'maintenance',
}

export default class InvitationModel extends Model {
  @attr('string') email!: string;
  @attr('string') role!: InvitationRole;
  @attr('string') subrole!: InvitationSubrole | null;
  @attr('string') status!: InvitationStatus;
  @attr('date') createdAt!: Date;
  @attr('date') resentAt?: Date;
  @attr('string') firstName?: string;
  @attr('string') lastName?: string;
  @attr('string') phoneNumber?: string;

  @belongsTo('client', { inverse: 'invitations', async: false })
  client?: ModelRegistry['client'];

  @hasMany('property', { async: false, inverse: null })
  properties!: ModelRegistry['property'][];

  @hasMany('multi-unit', { async: false, inverse: null })
  multiUnits!: ModelRegistry['multi-unit'][];

  @cached
  get hasClient(): boolean {
    return !!this.client?.id;
  }

  @cached
  get fullName(): string {
    return [this.firstName?.trim(), this.lastName?.trim()]
      .filter(Boolean)
      .join(' ');
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    invitation: InvitationModel;
  }
}
